module.exports = __webpack_public_path__ + "static/img/zhckzz.9c98fead.png";